import TableUI from "./TableUI";

interface TableProps {
  query: string;
  headers: string[];
  rows: any[];
}

function Table({ query, headers, rows }: TableProps) {
  return (
    <div>
      {query ? (
        <section className="text-gray-600 body-font pl-4">
          <TableUI headers={headers} rows={rows} />
        </section>
      ) : (
        <div className="w-full flex text-center h-80 justify-center items-center font-bold font-mono text-gray-400 text-2xl px-6">
          No data found.
        </div>
      )}
    </div>
  );
}

export default Table;
